import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./TaskResultPage.css";
import FakeNavigation from "../../../components/FakeNav/FakeNav";
import search from "../../../assets/search.png";

type TaskResult = {
  score: number;
  total: number;
  date?: string;
  attemptId: string;
  taskAttemptId?: string;
  taskIndex?: number | null;
  taskNumber?: number | null;
  totalTasks?: number;
  isFinalTask?: boolean;
};

type RouteState = {
  attemptId?: string;
  taskAttemptId?: string;
  taskIndex?: number;
  isFinalTask?: boolean;
  totalTasks?: number;
};

const MOSCOW_TIME_ZONE = "Europe/Moscow";

const formatCourseDate = (value?: string | null) => {
  const date = value ? new Date(value) : new Date();
  return Number.isNaN(date.getTime())
    ? new Date().toLocaleDateString("ru-RU", { timeZone: MOSCOW_TIME_ZONE })
    : date.toLocaleDateString("ru-RU", { timeZone: MOSCOW_TIME_ZONE });
};

const formatMoscowDateTime = (value?: string | null) =>
  value
    ? new Date(value).toLocaleString("ru-RU", { timeZone: MOSCOW_TIME_ZONE })
    : "";

const TaskResultPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [result, setResult] = useState<TaskResult | null>(null);
  const [results, setResults] = useState<TaskResult[]>([]);

  useEffect(() => {
    const state = location.state as RouteState | null;
    const savedResult = localStorage.getItem("taskResult");
    const savedResults = localStorage.getItem("taskResults");

    if (savedResults) {
      setResults(JSON.parse(savedResults));
    }

    if (savedResult) {
      setResult(JSON.parse(savedResult));
      return;
    }

    const attemptId =
      state?.attemptId ||
      localStorage.getItem("lastTaskAttemptId") ||
      localStorage.getItem("taskAttemptId") ||
      "";

    if (attemptId) {
      setResult({
        score: 0,
        total: 0,
        attemptId,
        taskAttemptId: state?.taskAttemptId || attemptId,
        taskIndex: state?.taskIndex,
        totalTasks: state?.totalTasks,
        isFinalTask: state?.isFinalTask,
      });
    }
  }, [location.state]);

  const sortedResults = useMemo(
    () =>
      [...results].sort((a, b) => Number(a.taskIndex || 0) - Number(b.taskIndex || 0)),
    [results]
  );
  const reviewAttemptId = result?.attemptId || "";
  const taskAttemptId =
    result?.taskAttemptId || localStorage.getItem("taskAttemptId") || "";
  const currentTaskIndex = Number(result?.taskIndex ?? 0);
  const totalTasks = result?.totalTasks || sortedResults.length || 1;
  const hasNextTask = Boolean(result && !result.isFinalTask && currentTaskIndex + 1 < totalTasks);

  const handleNextTask = () => {
    navigate("/task", {
      state: {
        taskAttemptId,
        taskIndex: currentTaskIndex + 1,
      },
    });
  };

  return (
    <div role="main">
      <div className="title"></div>
      <div className="title22">
        <div>Решение ситуационных задач - 3-й этап (Мультикейсы)</div>
        <div className="imgCont">
          <img src={search} alt="" style={{ width: 20 }} />
        </div>
      </div>
      <div className="task-result-breadcrumb">
        Мои курсы › Решение ситуационных задач - 3-й этап (Мультикейсы){" "}
        {formatCourseDate(result?.date)}
      </div>
      <div className="container">
        <div className="content">
          <div
            onClick={() => {
              localStorage.clear();
              navigate("/");
            }}
            className="gohome"
          >
            Выход
          </div>
          <h2>Ситуационная задача</h2>
          <p className="task-result-meta">Ограничение по времени: 30 мин.</p>
          <p className="task-result-meta">Метод оценивания: Последняя попытка</p>
          <h2>Результаты ваших предыдущих попыток</h2>
          <table className="generaltable">
            <thead>
              <tr>
                <th className="header c0" style={{ textAlign: "center" }}>
                  Попытка
                </th>
                <th className="header c1" style={{ textAlign: "left" }}>
                  Состояние
                </th>
                <th className="header c2" style={{ textAlign: "center" }}>
                  Просмотр
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedResults.length ? (
                sortedResults.map((item, index) => (
                  <tr key={item.attemptId}>
                    <td style={{ textAlign: "center" }}>{index + 1}</td>
                    <td style={{ textAlign: "left" }}>
                      Завершены
                      <span className="statedetails">
                        {item.date ? formatMoscowDateTime(item.date) : ""}
                      </span>
                      <span className="statedetails">
                        {item.total ? `${item.score} / ${item.total}` : ""}
                      </span>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <button
                        type="button"
                        className="task-link-button"
                        onClick={() =>
                          navigate("/task-review", {
                            state: {
                              attemptId: item.attemptId,
                              taskAttemptId: item.taskAttemptId,
                              taskIndex: item.taskIndex,
                              isFinalTask: item.isFinalTask,
                              totalTasks: item.totalTasks,
                            },
                          })
                        }
                      >
                        Просмотр
                      </button>
                    </td>
                  </tr>
                ))
              ) : result ? (
                <tr>
                  <td style={{ textAlign: "center" }}>1</td>
                  <td style={{ textAlign: "left" }}>
                    Завершены
                    <span className="statedetails">
                      {result.date ? formatMoscowDateTime(result.date) : ""}
                    </span>
                    <span className="statedetails">
                      {result.total ? `${result.score} / ${result.total}` : ""}
                    </span>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <button
                      type="button"
                      className="task-link-button"
                      onClick={() =>
                        navigate("/task-review", {
                          state: { attemptId: reviewAttemptId },
                        })
                      }
                    >
                      Просмотр
                    </button>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan={3} style={{ textAlign: "center" }}>
                    Нет данных о завершенной попытке
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="result_button_cont">
            {hasNextTask ? (
              <button type="button" onClick={handleNextTask}>
                Перейти к следующей ситуационной задаче
              </button>
            ) : (
              <p>Все ситуационные задачи завершены.</p>
            )}
          </div>
        </div>
        <FakeNavigation />
      </div>
    </div>
  );
};

export default TaskResultPage;
